import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/gaushala/schemes";

export const Route = createFileRoute("/admin/_gaushala/gaushala-schemes")({
  component: Page,
});
